import React from 'react';
import { Link, useLocation } from 'react-router-dom';



const NavLink = ({ to, icon, secIc, title, className }) => {

    return (
        <Link className={className + ' nav-link py-1 text-start px-1 rounded-pill mx-1'} to={to}>
            <div className='d-flex align-items-center'>
                <img width={38} height={38} src={icon} />
                <span className='px-2'>{title}</span>
                <img src={secIc} />
            </div>
        </Link>
    );
};

export default NavLink;
